export const printPaymentReceipt = (appt) => {
  if (!appt) return alert("Invalid appointment");

  const printedAt = new Date().toLocaleString();

  const html = `
  <html>
  <head>
    <title>Payment Receipt</title>
    <style>
      * {
        box-sizing: border-box;
      }
      body {
        margin: 0;
        padding: 0;
        font-family: monospace;
        background: #fff;
      }
      .receipt {
        width: 302px; /* 80mm */
        padding: 8px;
      }
      .center {
        text-align: center;
      }
      .bold {
        font-weight: bold;
      }
      .title {
        font-size: 18px;
        font-weight: bold;
      }
      .divider {
        border-top: 1px dashed #000;
        margin: 6px 0;
      }
      .separator {
        border-top: 2px solid #000;
        margin: 8px 0;
      }
      .row {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        margin: 2px 0;
      }
      .amount {
        font-size: 24px;
        font-weight: bold;
        margin: 6px 0;
      }
      .small {
        font-size: 11px;
      }
      .section-heading {
        font-size: 13px;
        font-weight: bold;
        margin: 8px 0 4px 0;
      }
      .payment-box {
        background: #f5f5f5;
        padding: 8px;
        margin: 6px 0;
        border-radius: 4px;
      }
      /* ✅ Reduced size for printed timestamp */
      .printed-timestamp {
        text-align: center;
        font-size: 8px;
        color: #666;
        margin-top: 6px;
      }
      .developer-credit {
        text-align: center;
        margin-top: 8px;
        padding-top: 6px;
        border-top: 1px solid #000;
        font-size: 9px;
        color: #333;
      }
      @media print {
        body { margin: 0; }
      }
    </style>
  </head>

  <body>
    <div class="receipt">

      <div class="center">
        <div class="title">Zainab Medical & Children Care Centre</div>
        <div class="small">Payment Receipt</div>
      </div>

      <div class="divider"></div>

      <div class="center">
        <div class="small">Receipt ID</div>
        <div class="bold">${appt.payment?.receiptId || "-"}</div>
      </div>

      <div class="divider"></div>

      <!-- Patient Information Section -->
      <div class="section-heading">Patient Information</div>

      <div class="row">
        <span class="bold">MR</span>
        <span>${appt.mrCode || "-"}</span>
      </div>

      <div class="row">
        <span class="bold">Name</span>
        <span>${appt.pName}</span>
      </div>

      <div class="row">
        <span class="bold">Father</span>
        <span>${appt.fatherName || "-"}</span>
      </div>

      <div class="row">
        <span class="bold">Dept</span>
        <span>${appt.department}</span>
      </div>

      <div class="row">
        <span class="bold">Doctor</span>
        <span>${appt.doctor?.name || "-"}</span>
      </div>

      <div class="row">
        <span class="bold">Appt #</span>
        <span>${appt.appointmentNumber || "-"}</span>
      </div>

      <!-- Separator line between sections -->
      <div class="separator"></div>

      <!-- Payment Details Section -->
      <div class="section-heading">Payment Details</div>

      <div class="payment-box">
        <div class="center">
          <div class="small">Amount Paid</div>
          <div class="amount">Rs ${appt.payment?.feePaid || 0}</div>
        </div>
        
        <div class="divider"></div>
        
        <div class="row">
          <span class="bold">Method</span>
          <span>${appt.payment?.method || "Cash"}</span>
        </div>
        
        <div class="row">
          <span class="bold">Date</span>
          <span>${appt.date || "-"}</span>
        </div>
      </div>

      <div class="divider"></div>

      <div class="center small" style="margin-top:6px;">
        Thank you for your payment
      </div>

      <div class="center small">
        Ph: +923152189910 (Whatsapp Only) / +923153051011 · www.shoaibhospital.cloud
      </div>

      <!-- Developer credit section -->
      <div class="developer-credit">
        Computer Software Developed by<br/>
        Bilal Consultancy, Ph: 03152311183
      </div>

      <!-- ✅ Printed timestamp moved to the very end with smaller size -->
      <div class="printed-timestamp">
        Printed: ${printedAt}
      </div>

    </div>

    <script>
      window.onload = () => window.print();
    </script>
  </body>
  </html>
  `;

  const w = window.open("", "_blank", "width=340,height=700");
  w.document.write(html);
  w.document.close();
};